import './index.scss';
import Timeline from '../timeline/lib/timeline';
import validator from 'utils/validator';
import 'components/empty_list_message';
import 'components/modals/crop_image_modal';

import '../timeline/components/new_activity';
import '../timeline/components/timeline_filter';
import '../timeline/components/timeline_loader';
import '../timeline/components/sidebar_box';
import '../timeline/components/about_box';
import '../timeline/components/profile_box';
import '../timeline/components/resources_box';
import '../timeline/components/notebooks_card_list';
import '../timeline/components/achievements/big_achievement_box';
import '../timeline/components/achievements/all_achievements';

import '../timeline/components/activity/index.scss';
import '../timeline/components/activity_comment/index.scss';
import '../timeline/components/activity_reply/index.scss';

(function () {
  'use strict';
  validator.init();
  (new Timeline()).start();
})();
